import React from 'react';
import Gravatar from 'react-gravatar';
import StatusBar from './StatusBar';
import Formatter from '../psuite-js/helpers/formatter';

const MDeliveryHeader = ({document}) => {
    const vehicle = document.vehicle || {};
    const user = vehicle.user || {};
    const phones = user.phones || {};

    return (
        <div className="md-header">
            <div className="md-header-user">
                <div className="gravatar">
                    <Gravatar email={user.email || 'unknow@polibrasnet.com.br'} size={48} default="mm" className="avatar" />
                </div>

                <div className="user-data">
                    <h4>{user.display_name}</h4>
                    <small>{Formatter.formatPhone(phones.main)}</small>
                </div>
            </div>

            <StatusBar document={document} />
        </div>
    );

}

export default MDeliveryHeader;



// WEBPACK FOOTER //
// ./src/components/MDeliveryHeader.js